var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.739,
    height: 17.739,
    viewBox: "0 0 17.739 17.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9593",
    "data-name": "Group 9593",
    transform: "translate(5552.369 7369.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9314",
    "data-name": "Group 9314",
    transform: "translate(-5552.369 -7369.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13562",
    "data-name": "Path 13562",
    d: "M3.774,5.548H2V17.965a1.779,1.779,0,0,0,1.774,1.774H16.191V17.965H3.774ZM17.965,2H7.322A1.779,1.779,0,0,0,5.548,3.774V14.417a1.779,1.779,0,0,0,1.774,1.774H17.965a1.779,1.779,0,0,0,1.774-1.774V3.774A1.779,1.779,0,0,0,17.965,2Zm0,12.417H7.322V3.774H17.965Z",
    transform: "translate(-2 -2)",
    fill: "#65c3c3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13668",
    "data-name": "Path 13668",
    d: "M12.006,8.8c.329-.585.946-.93,1.307-1.443A.989.989,0,0,0,12.4,5.8a1.274,1.274,0,0,0-1.2.986l-1.1-.457a2.389,2.389,0,0,1,2.293-1.668A2.268,2.268,0,0,1,14.4,5.671a2.01,2.01,0,0,1,.008,2.06c-.505.746-.986.97-1.251,1.451-.1.192-.144.321-.144.946H11.8A2.713,2.713,0,0,1,12.006,8.8Zm-.449,3.039A.83.83,0,0,1,12.4,11a.838.838,0,0,1,0,1.676A.842.842,0,0,1,11.557,11.836Z",
    transform: "translate(-5554.354 -7371.33)",
    fill: "#65c3c3",
    stroke: "#65c3c3",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFaq);
export default __webpack_public_path__ + "static/media/sidebar_faq.a2f926a42c1a6f0e78bdeba0aa550b8c.svg";
export { ForwardRef as ReactComponent };